export default __webpack_public_path__ + "static/andrew-450x520-b5f163176289a0a52532bd4eaeed300d.jpg";